import { Box, Container, Link, Typography, styled, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ShortDisclaimer } from '../Legal';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper className="footer-wrapper">
      <Box pb={4}>
        <ShortDisclaimer variant="footer" />
        <Divider sx={{ my: 2 }} />

        <Box
          display={{ xs: 'block', md: 'flex' }}
          alignItems="center"
          textAlign={{ xs: 'center', md: 'left' }}
          justifyContent="space-between"
          flexWrap="wrap"
          gap={{ xs: 2, md: 0 }}
        >
          <Box>
            <Typography variant="subtitle1">
              &copy; {currentYear} - Portfoliomatic
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
              gap: 2,
              flexWrap: 'wrap'
            }}
          >
            <Link component={RouterLink} to="/settings?tab=support" variant="body2">
              Support Portfoliomatic
            </Link>
            <Typography variant="body2" color="text.secondary">•</Typography>
            <Link component={RouterLink} to="/disclaimer" variant="body2">
              Disclaimer
            </Link>
            <Typography variant="body2" color="text.secondary">•</Typography>
            <Link component={RouterLink} to="/terms" variant="body2">
              Terms of Use
            </Link>
            <Typography variant="body2" color="text.secondary">•</Typography>
            <Link component={RouterLink} to="/privacy" variant="body2">
              Privacy Policy
            </Link>
            <Typography variant="body2" color="text.secondary">•</Typography>
            <Link
              href="mailto:contact@portfoliomatic.ca"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
            >
              Contact Us
            </Link>
          </Box>
        </Box>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
